module.exports = __webpack_public_path__ + "img/info.2c6fea72.png";